import ModalLayout from "../Layouts/ModalLayout/ModalLayout";
import React from "react";
import styles from "./styles.module.scss";
import Button from "../Button/ButtonVariant";
import NoEye from "../../../public/images/no-eye.svg";
import { useTranslation } from 'react-i18next';

interface PostNoViewsModalProps {
  onClose: () => void;
  isOpen: boolean;
  isDemoSpace?: boolean;
}

const PostNoViewsModal = (props: PostNoViewsModalProps) => {
  const { t } = useTranslation();
  const { isOpen, onClose } = props;

  const title = !props.isDemoSpace
    ? t("Views and Likes info is unavailable")
    : t("Inspiration Spaces");
  const description = !props.isDemoSpace
    ? t("The owner of this group has disabled post data information")
    : t("Views and Likes info is unavailable in this Space but are available for PRO members in real Spaces and Groups!");

  return (
    <ModalLayout isOpen={isOpen} onClose={onClose}>
      <div className={styles.content_wrapper}>
        <img src={NoEye} alt="icon" width={40} height={40} />
        <div className={styles.info_block}>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <Button title={t("Ok")} buttonType="primary" onClickFunc={onClose} />
      </div>
    </ModalLayout>
  );
};

export default PostNoViewsModal;
